import { fetchBoard } from 'API';
import { RANDOM_BOARD_ID } from 'BoardID';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { RouteParams } from 'Types';
import useReactRouter from 'use-react-router';

import { useLoadBoard } from 'state/recoilBoardActions';
import {
  boardInstanceAtomFamily,
  routerMatchAtom,
  selectedBoardIDAtom,
} from 'state/recoilState';

function BoardIDEffects() {
  const { match } = useReactRouter<RouteParams>();

  const [selectedBoardID, setSelectedBoardID] =
    useRecoilState(selectedBoardIDAtom);
  const selectedBoard = useRecoilValue(
    boardInstanceAtomFamily(selectedBoardID)
  );
  const setRouterMatch = useSetRecoilState(routerMatchAtom);

  const loadBoard = useLoadBoard();

  // Read router match from recoil instead of react-router itself
  // so that recoil can manage all of the state transitions
  useEffect(() => {
    setRouterMatch(match);
  }, [match, setRouterMatch]);

  // Keep the selectedBoardID in sync with the router
  useEffect(() => {
    if (
      (match.path === '/designer/id/:boardID' ||
        match.path === '/build_steps/id/:boardID') &&
      match.isExact
    ) {
      setSelectedBoardID(match.params.boardID);
    } else if (
      (match.path === '/designer/hash/:boardHash' ||
        match.path === '/build_steps/hash/:boardHash') &&
      match.isExact
    ) {
      setSelectedBoardID(JSON.parse(atob(match.params.boardHash)).id);
    }
  }, [match, loadBoard, selectedBoardID, selectedBoard, setSelectedBoardID]);

  // If the selected board ID is not found, try and fetch it
  useEffect(() => {
    if (
      selectedBoardID &&
      selectedBoardID !== RANDOM_BOARD_ID &&
      selectedBoard == null
    ) {
      fetchBoard(selectedBoardID).then(loadBoard, console.error);
    }
  }, [loadBoard, selectedBoardID, selectedBoard]);

  return null;
}

export default BoardIDEffects;
